import React from 'react';
import { Check } from 'lucide-react';
import { ESTADO_ICONO, ESTADO_PILL, ESTADO_SOLIDO } from 'lib/estadoUi';

// Los tres estados de un ítem como botones grandes, uno debajo del otro, para
// marcarlos con el pulgar y con guantes. Sin marcar, los tres se ven iguales
// (blanco, borde gris, solo el ícono en una pastilla de su color): Aprobado no
// puede parecer ya elegido. Marcado, se rellena con el color de estadoUi
// (verde, ámbar, rojo).
const OPCIONES = [
  { v: 'aprobado', label: 'Aprobado', Icon: ESTADO_ICONO.aprobado },
  { v: 'alerta', label: 'Alerta', Icon: ESTADO_ICONO.alerta },
  { v: 'falla', label: 'Falla', Icon: ESTADO_ICONO.falla },
];

const NEUTRO = 'border-border bg-white text-foreground';

// valor: 'aprobado' | 'alerta' | 'falla' | undefined ; onMarcar(v)
export default function BotonesEstado({ valor, onMarcar }) {
  return (
    <div className="grid grid-cols-1 gap-3" role="group" aria-label="Estado del ítem">
      {OPCIONES.map((o) => {
        const activo = valor === o.v;
        return (
          <button
            key={o.v}
            type="button"
            aria-pressed={activo}
            data-estado={o.v}
            onClick={() => onMarcar(o.v)}
            style={{ touchAction: 'manipulation' }}
            className={`flex min-h-[64px] w-full items-center gap-4 rounded-2xl border-2 px-5 text-left text-xl font-bold shadow-card transition-colors duration-150 active:scale-[0.99] ${
              activo ? ESTADO_SOLIDO[o.v] : NEUTRO
            }`}
          >
            <span
              aria-hidden="true"
              className={`flex shrink-0 items-center justify-center rounded-full border p-1 ${activo ? 'border-transparent' : ESTADO_PILL[o.v]}`}
            >
              <o.Icon size={26} strokeWidth={2.5} />
            </span>
            <span className="flex-1">{o.label}</span>
            {activo ? <Check size={22} strokeWidth={3} aria-hidden="true" className="shrink-0" /> : null}
          </button>
        );
      })}
    </div>
  );
}
